import { defineFcm } from '../shared/factory';

export const FCM_PETITION_UPDATE_EMAIL_PREVIEW_ENABLED = defineFcm('petition_update_email_preview_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'petition update',
		description: 'Whether to display the "preview email" button on the create petition update page.',
		import: false,
	});
